// extracted by mini-css-extract-plugin
export default {"card":"card__3f974aab","row":"row__3f974aab","info":"info__3f974aab","price":"price__3f974aab"};